import { ICallScribeTimeEntryOption } from 'services/callScribe/types';

export const pickDefaultOptionValue = (
  options: ICallScribeTimeEntryOption[] | undefined | null,
): string => {
  if (!Array.isArray(options) || options.length === 0) {
    return '';
  }
  const flagged = options.find(o => Boolean(o?.isDefault) && typeof o?.value === 'string');
  return flagged?.value ?? '';
};

export const defaultOptionLabel = (
  options: ICallScribeTimeEntryOption[] | undefined | null,
): string | undefined => {
  if (!Array.isArray(options)) {
    return undefined;
  }
  const flagged = options.find(o => Boolean(o?.isDefault));
  const label = flagged?.label;
  return typeof label === 'string' && label.trim().length > 0 ? label.trim() : undefined;
};

export const selectableOptions = (
  options: ICallScribeTimeEntryOption[] | undefined | null,
): ICallScribeTimeEntryOption[] => {
  if (!Array.isArray(options)) {
    return [];
  }
  return options.filter(
    o => o && typeof o.value === 'string' && o.value.length > 0 && typeof o.label === 'string',
  );
};
